export async function loadIncompleteSystemContractDetails(api, system) {
    if (!system?.id) return

    try {
        const response = await api.json('GET', `/systems/${system.id}/customer-contract/incomplete-solar-system-details`)
        return await response.json()
    } catch (err) {
        console.error('Failed to load contract details:', err)
    }
}